module.exports = __webpack_public_path__ + "static/Portrait-6d6c0c9f5afeb51eb5915c09d6ed0aaf.jpg";